import './Amenities.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

const Amenities = () => {
  return (
    <div data-aos="fade-up"
      data-aos-duration="2000">
      <div className='swissamenities-top'>
        <h3>AMENITIES AT A GLANCE</h3>
      </div>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="swissmySwiper"
      >
        <SwiperSlide><img src="./DowntownPhotos/Amenities/1.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./DowntownPhotos/Amenities/2.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./DowntownPhotos/Amenities/3.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./DowntownPhotos/Amenities/4.jpg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./DowntownPhotos/Amenities/5.jpg" alt="AenitiesPics" /></SwiperSlide>
      </Swiper>
    </div>
  )
}

export default Amenities










